// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__2jzqV","active":"NavigationItem_active__2ZAxq"};